// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2UouC","inputWrap":"Table_inputWrap__1BBok","col":"Table_col__y-CWp","bmiTooltip":"Table_bmiTooltip__12_21"};